import { render } from "./Login.vue?vue&type=template&id=6098007c"
import script from "./Login.ts?vue&type=script&lang=ts"
export * from "./Login.ts?vue&type=script&lang=ts"
script.render = render

export default script